export const sanitizeInput = (value: string): string => {
  return value.replace(/<\/?[^>]+(>|$)/g, '');
};
